import { Fragment } from "react";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row } from "react-bootstrap";

const EmailSettingHeader = () => {
  return (
    <Fragment>
      <Row className="align-items-center position-relative g-0">
        <Col xl={8}>
          <div className="d-flex align-items-center header-content-flex-wrapper">
            {/* AI Icon with Clean Design */}
            <div 
              className="rounded-circle d-flex align-items-center justify-content-center me-4 logo-container-responsive"
              style={{ 
                width: "64px", 
                height: "64px",
                background: 'linear-gradient(135deg, #00d4ff 0%, #0ea5e9 100%)',
                boxShadow: '0 0 30px rgba(0, 212, 255, 0.6)',
                animation: 'pulse 3s infinite'
              }}
            >
              <FontAwesomeIcon 
                icon={faEnvelope} 
                className="text-white" 
                size="2x"
                style={{ 
                  filter: 'drop-shadow(0 0 8px rgba(255, 255, 255, 0.8))',
                  animation: 'glow 2s ease-in-out infinite alternate'
                }}
              />
            </div>
            
            <div className="text-content-container-responsive">
              <h1 
                className="mb-2 profile-title-responsive" 
                style={{ 
                  color: '#1f2937',
                  textShadow: '0 0 20px rgba(0, 212, 255, 0.3)',
                  fontSize: '1.7rem',
                  fontWeight: 700,
                  background: 'linear-gradient(135deg, #1f2937 0%, #374151 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }}
              >
                AI Email Intelligence Hub
              </h1>
              <p 
                className="mb-0 profile-subtitle-responsive" 
                style={{ 
                  fontSize: '1.1rem',
                  color: '#6b7280',
                  textShadow: '0 0 10px rgba(0, 212, 255, 0.2)'
                }}
              >
                Neural network-powered email automation and management center
              </p>
            </div>
          </div>
        </Col>
        
        <Col xl={4} className="text-end status-indicator-col-responsive">
          {/* AI Status Indicator */}
          <div 
            className="d-inline-flex align-items-center status-indicator-div-responsive"
            style={{
              background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.25) 0%, rgba(217, 119, 6, 0.25) 100%)',
              padding: '12px 24px',
              borderRadius: '16px',
              border: '1px solid rgba(245, 158, 11, 0.5)',
              backdropFilter: 'blur(10px)',
              boxShadow: '0 0 15px rgba(245, 158, 11, 0.3)'
            }}
          >
            <div 
              className="rounded-circle me-3"
              style={{
                width: '12px',
                height: '12px',
                background: '#f59e0b',
                animation: 'pulse 2s infinite',
                boxShadow: '0 0 10px rgba(245, 158, 11, 0.8)'
              }}
            />
            <span 
              className="fw-bold"
              style={{ 
                fontSize: '14px',
                color: '#d97706',
                textTransform: 'uppercase',
                letterSpacing: '1px',
                textShadow: '0 0 5px rgba(245, 158, 11, 0.5)'
              }}
            >
              SETUP MODE
            </span>
          </div>
        </Col>
      </Row>

      {/* AI Animation Styles */}
      <style dangerouslySetInnerHTML={{
        __html: `
          @keyframes pulse {
            0% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.05); opacity: 0.8; }
            100% { transform: scale(1); opacity: 1; }
          }
          
          @keyframes glow {
            0% { filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.8)); }
            100% { filter: drop-shadow(0 0 16px rgba(255, 255, 255, 1)); }
          }
          
          .ai-hover-lift {
            transition: all 0.3s ease;
          }
          
          .ai-hover-lift:hover {
            transform: translateY(-5px);
            transition: all 0.3s ease;
            box-shadow: 0 12px 40px rgba(0, 212, 255, 0.2);
          }

          @media (max-width: 500px) {
            .header-content-flex-wrapper {
              flex-direction: column;
              align-items: flex-start !important;
            }
            .logo-container-responsive {
              width: 100% !important;
              justify-content: center !important;
              margin-right: 0 !important;
              margin-bottom: 0.75rem;
            }
            .text-content-container-responsive {
              width: 100%;
            }
            .profile-title-responsive {
              font-size: 1.2rem !important;
              text-align: center;
            }
            .profile-subtitle-responsive {
              text-align: center;
            }
            .status-indicator-col-responsive {
              width: 100%;
              text-align: center !important;
            }
            .status-indicator-div-responsive {
              margin-top: 16px;
            }
          }
        `
      }} />
    </Fragment>
  );
};

export default EmailSettingHeader;